
import styled from 'styled-components';

export const Styles = styled.div`
	.select-before {
		width: 90px;
	}

  .icon-mt {
    margin-top: 4px;
  }

	.d-flex {
		margin-top: 0.5em;
		display: flex;
		justify-content: space-between;
	}
	.remove-button-for-repeatable {
		margin: 0px 15px -15px 0px;
		background: white;
		button {
			padding: 0 2px 0 5px;
			top: 2px;
			position: relative;
		}
	}
	.anticon{
		vertical-align: 0;
	}
	.ant-form {
		margin: 0px 0px var(--size) 0;
		.ant-form-item {
			margin-bottom: 8px;
		}
		label {
			font-weight: 500;
			color: rgba(0, 0, 0, 0.65);
		}
	}
	.ant-picker {
		width: 100%;
		.ant-picker-suffix {
			margin-top: -6px;
		}
		.ant-picker-clear {
			margin-top: -3px;
		}
	}
	.ant-input-number {
		width: 100%;
	}
	.ant-form-item-label {
		display: flex;
    justify-content: space-between;
		align-items: center;
		a {
			font-size: 14px;
			color: var(--mmt-primary-70);
			user-select: none;
		}
	}
	.repeatable {
		padding: var(--size) var(--size);
		border: 1.5px dashed var(--color-primary-70);
		> div {
			margin-bottom: 0;
		}
		&:nth-of-type(1) {
			border-top-left-radius: 3px;
			border-top-right-radius: 3px;
		}
		&:last-of-type {
			padding-bottom: 8px;
			margin-bottom: 8px;
			border-bottom-left-radius: 3px;
			border-bottom-right-radius: 3px;
		}
	}
  p.repeatable {
    padding-top: 8px !important;
    margin-bottom: var(--size-lg) !important;
  }
	.second {
	 	&:nth-of-type(2) {
			background: black;
			margin-top: var(--size);
	 	}
	}
	.comment-add-btn.danger {
		color: red;
  }
  .mt-16 {
    margin-top: var(--size);
	}
	.total {
		flex-grow: 1;
		.ant-space-item:nth-of-type(1) {
			flex-grow: 1;
		}
		.ant-space-item:nth-of-type(2) {
			max-width: 100px;
			min-width: 100px;
		}
		button {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
		}
	}
	.total:not(:first-of-type) {
		margin-top: 8px;
	}
	.total100 {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		width: 100%;
	}
	.error {
		margin-top: 8px;
		color: red;
	}
	.ant-form-item-control-input-content {
		> span {
			width: 100%;
			.ant-upload {
				width: 100%;
			}
		}
	}
	.with-comment .ant-form-item-extra {
			position: absolute;
			right: 0;
			top: -30px;
	}
	.ant-select-item.ant-select-item-option .ant-select-item-option-content {
		white-space: normal!important;
	}
	td.ant-descriptions-item-content {
    background-color: white;
	}
	.form-loader {
		position: absolute;
		right: 0;
		top: 0;
		left: 0;
		bottom: 0;
		.loader{
			position: absolute;
		}
	}
	.group-header{
			font-family: SF UI Display;
			color: var(--color-primary-70);
      position: relative;
      button{
        top: -4px;
        left: -3px;
      }
			&::after {
				content: '';
				position: absolute;
				width: 100%;
				height: 1px;
				background: #F4F5F8;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				margin: auto;
				z-index: -1;
			}
		}
	label {
		display: block;
	}
`;

export const FormStyles = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
  
	.form-loader {
		position: absolute;
		right: 0;
		top: 55px;
		left: 0;
		bottom: 0;
		.loader{
			position: absolute;
		}
	}
	.form {
		max-width: 630px;
		flex-grow: 1;
		padding: var(--size);
		overflow-y: auto;
		height: 100%;
	}
	.forms {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		overflow-y: auto;
		width: 350px;
		max-height: 100%;
		height: 100%;
		background: #fafafa;
		border-right: 1px solid rgba(0,0,0,0.1);
		button {
			display: flex;
			flex-direction: row;
			justify-content: start;
			align-items: center;
			text-align: start;
			height: fit-content;
			padding: var(--size);
			white-space: pre-wrap;
			> span[role="img"]:nth-of-type(1) {
				font-size: var(--size-lg);
				color: rgba(0, 0, 0, 0.55);
				margin-right: var(--size);
			}
			> div {
				width: 100%;
				align-items: center;
				span {
					font-size: 14px;
				}
				> div {
					span:nth-of-type(1) {
						font-weight: 500;
						color: rgba(0, 0, 0, 0.65);
					}
					span:nth-of-type(2) {
						font-size: 12px;
						color: rgba(0, 0, 0, 0.55);
					}
				}
			}
		}
		button.active {
			background: rgba(161, 194, 250, 0.16);
			border: none;
			> span[role="img"]:nth-of-type(1) {
				color: var(--color-primary-70);
			}
			> div {
				> div {
					span:nth-of-type(1) {
						color: var(--color-primary-70);
					}
				}
			}
		}
	}
  .i-switch .ant-col.ant-form-item-control {
    align-items: flex-end;
  }
  .i-switch.with-comment .ant-col.ant-form-item-control {
    justify-content: space-between;
  }
  .i-switch .ant-col.ant-form-item-control {
    justify-content: center;
  }
  .total .ant-space-item:nth-of-type(1) {
    width: 100%;
  }
  .forms .anticon-info-circle svg {
      margin-top: -6px;
  }
  .forms::-webkit-scrollbar {
    display: none;
  }
  .title-semibold-4 {
    max-width: 80%;
  }
  .i-switch {
    min-height: 60px;
    .ant-col.ant-form-item-control {
      flex-direction: column-reverse;
    }
    .ant-form-item-extra {
      top: 0;
    }
  }
	.i-radioGroup, .i-checkboxGroup {
		background: #FFFFFF;
		border: 0.5px solid #D7DAEA;
		box-sizing: border-box;
		border-radius: 2px;
		padding: var(--size-lg);
		margin-top: var(--size-lg);

		.ant-radio-group.ant-radio-group-outline, .ant-checkbox-group {
			width: 100%;

			label {
				display: flex;
				min-height: 76px;
				background: white;
				border: 1px solid #d7daea;
				box-sizing: border-box;
				border-radius: 2px;
				margin: var(--size-lg) 0;
				padding: 13px var(--size-lg);

				&.ant-radio-wrapper-checked {
					border-color: var(--color-primary-70);
				}

				.ant-radio, .ant-checkbox {
					margin: auto;
					width: var(--size);
				}

				&>span:last-child {
					width: calc(100% - 32px);
					display: flex;
					flex-direction: column;
					margin: auto;

					.radio-title {
						font-style: normal;
						font-weight: 600;
						font-size: var(--font-size-lg);
						line-height: var(--size-lg);
						display: flex;
						align-items: center;
						color: #001529;
						white-space: normal !important;
					}

					.radio-description {
						font-style: normal;
						font-weight: normal;
						font-size: 14px;
						line-height: 22px;
						display: flex;
						align-items: center;
						white-space: normal !important;
					}
				}
			}
		}
	}
`
